import Address from "@mapmycustomers/shared/types/Address";
import { RouteEndLocation, RouteStartLocation } from "@mapmycustomers/shared/types/entity/Route";
import { RouteEdgeEntity } from "@mapmycustomers/shared/types/entity/RouteDetail";
import { GeoPoint } from "@mapmycustomers/shared/types/shapes";
import getFormattedAddressForUi from "@mapmycustomers/shared/util/formatters/getFormattedAddressForUi";

export interface EdgeLocationState {
  address?: Address;
  entity?: RouteEdgeEntity;
  geoPoint?: GeoPoint;
}

// A saved place may have no street line (null); a Google city pick's is "" and stays unsent
export const getEdgeAddressString = (address?: Address) =>
  address?.formattedAddress ?? address?.address ?? getFormattedAddressForUi(address);

// Exactly-one-variant rule (BE spec): the entity wins when alive; otherwise the
// cached/manual address+geoPoint pair. A gone entity (binding kept in state but no
// live projection) intentionally falls through to the manual variant — the BE
// clears the broken binding on save.
export const buildStartLocationPayload = ({
  address,
  entity,
  geoPoint,
}: EdgeLocationState): RouteStartLocation | undefined => {
  if (entity) {
    return { startEntity: entity };
  }
  const addressString = getEdgeAddressString(address);
  return addressString && geoPoint
    ? { startAddress: addressString, startGeoPoint: geoPoint }
    : undefined;
};

export const buildEndLocationPayload = ({
  address,
  entity,
  geoPoint,
}: EdgeLocationState): Partial<RouteEndLocation> => {
  if (entity) {
    return { endEntity: entity };
  }
  const addressString = getEdgeAddressString(address);
  return addressString && geoPoint ? { endAddress: addressString, endGeoPoint: geoPoint } : {};
};
